import React from "react";

export default function PolicyTable({
  policies = [],
  onCreateVersion,
  onShowVersions
}) {

  if (policies.length === 0) {

    return (
      <div className="policy-empty">
        No policies found
      </div>
    );
  }

  return (

    <div className="policy-table-wrapper">

      <table className="policy-table">

        <thead>

          <tr>

            <th>Name</th>

            <th>Version</th>

            <th>Priority</th>

            <th>Effect</th>

            <th>Status</th>

            <th>Actions</th>

          </tr>

        </thead>

        <tbody>

          {policies.map(policy => (

            <tr
              key={policy.policyId}
            >

              <td className="policy-name">
                {policy.policyName}
              </td>

              <td className="policy-version">
                v{policy.version}
              </td>

              <td>
                {policy.priority}
              </td>

              <td>
                {policy.effect}
              </td>

              <td>

                <span
                  className={`status-badge ${policy.status.toLowerCase()}`}
                >
                  {policy.status}
                </span>

              </td>

              <td className="policy-actions">

                <button
                  className="btn btn-secondary"
                  onClick={() =>
                    onShowVersions?.(policy)
                  }
                >
                  Versions
                </button>

                <button
                  className="btn btn-primary"
                  onClick={() =>
                    onCreateVersion?.(policy)
                  }
                >
                  New Version
                </button>

              </td>

            </tr>

          ))}

        </tbody>

      </table>

    </div>

  );
}